import * as React from "react";
import { overrideCSS } from '../../utils/function';

interface IProps {
    value: number;
    styles?: Object;
    showValueWithArrow?: boolean;
}
const internalStyles = require('./styles.pcss');

export class ArrowIndicator extends React.Component<IProps, {}>{

    render() {
        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;

        let { value } = this.props;
        let display = <span></span>;
        if (!isNaN(value)) {
            
            // this was the only way I could get some level of consistency with the up vs down arrow - value spacing throughout the responsive view
            // Including showValueWithArrow display option (refactor needed perhaps)
            if(!this.props.showValueWithArrow){
                if (value > 0) {
                    display = <span className={ styles.upArrow }>
                    </span>;
                } else if (value < 0) {
                    display = <span>
                        <span className={ styles.downArrow }></span>
                        <span></span>
                    </span>;
                } else {
                    display = <span className={ styles.transparentArrow }></span>;
                }
            } else {
                if (value > 0) {
                    display = <span className={ styles.upArrow }>
                        <span className={ styles.value }>{ value }</span>
                    </span>;
                } else if (value < 0) {
                    display = <span>
                        <span className={ styles.downArrow }></span>
                        <span></span>
                        <span className={ styles.value }>{ value }</span>
                    </span>;
                } else {
                    display = <span className={ styles.transparentArrow }>{ value }</span>;
                }
            }
            
        }
        return display;

    }
}


// WEBPACK FOOTER //
// ./src/client/assets/ArrowIndicator/ArrowIndicator.tsx